import { Link, useNavigate } from "react-router";
import axiosInstance from "../common/api";
import dayjs from "dayjs";
import { DatePicker, InputNumber } from "antd";
import { date2locale, downloadFile } from "../common/common";
import { DownloadOutlined } from "@ant-design/icons";
import TablePage from "../components/TablePage";
import DebounceSelect from "../common/DebounceSelect";
import { filter } from "lodash";
import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  {
    title: "Num.",
    ellipsis: true,
    key: "id",
    dataIndex: "id",
    width: 70,
    render: (x) => <Link to={`${x}`}>{x}</Link>,
  },
  {
    title: "Causale",
    key: "reason",
    dataIndex: ["reason", "reason"],
    ellipsis: true,
    width: 250,
  },
  {
    title: "Data",
    key: "date",
    dataIndex: "date",
    ellipsis: true,
    width: 120,
  },
  {
    title: "Dipendente",
    key: "employee",
    dataIndex: "employee",
    render: (emp) => emp && emp.lastName + " " + emp.firstName,
    width: 300,
    ellipsis: true,
  },
  {
    title: "Allegato",
    key: "reportRef",
    dataIndex: "id",
    render: (id, record) =>
      record.reportRef && (
        <DownloadOutlined onClick={() => downloadFile(`dpiTransaction/${id}/report`)} />
      ),
    width: 80,
    ellipsis: true,
  },
];

const filterItems = [
  {
    name: "id",
    label: "ID",
    formItem: {
      children: <InputNumber style={{ width: "100%" }} controls={false} precision={0} />,
    },
  },
  {
    name: "employee",
    label: "Dipendente",
    readableValue: (value) => JSON.parse(value).label,
    formItem: {
      children: (
        <DebounceSelect
          fetchOptions={(query) =>
            axiosInstance
              .get("employeeCompact", {
                params: {
                  startDate: "1900-01-01",
                  endDate: "9999-01-01",
                  query,
                },
              })
              .then(({ data }) =>
                data.map((x) => ({
                  label: x.fullName,
                  value: x.id,
                })),
              )
          }
        />
      ),
      props: {
        getValueProps: (value) => ({
          value: value && JSON.parse(value),
        }),
        normalize: (value) => JSON.stringify(value),
      },
    },
  },
  {
    name: "date",
    label: "Data",
    readableValue: (value) =>
      `Dal ${date2locale(value.split("_")[0])} al ${date2locale(value.split("_")[1])}`,
    formItem: {
      children: <DatePicker.RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />,
      props: {
        getValueProps: (value) => ({
          value: value ? [dayjs(value.split("_")[0]), dayjs(value.split("_")[1])] : [],
        }),
        normalize: (value) =>
          value.length === 2 && value[0].format("YYYY-MM-DD") + "_" + value[1].format("YYYY-MM-DD"),
      },
    },
  },
];

export default function DpiTransactions() {
  const navigate = useNavigate();

  const fetch = (params) => {
    if (params.employee) params.employee = JSON.parse(params.employee).value;
    if (params.date) {
      params.startDate = params.date.split("_")[0];
      params.endDate = params.date.split("_")[1];
      delete params.date;
    }
    return axiosInstance.get("dpiTransaction", { params }).then(({ data }) => data);
  };

  return (
    <SimpleTablePage filterItems={filterItems} columns={columns} resource={"dpiTransaction"} />
  );
}
